export const API_URLS = {
    IS_AUTHENTICATED: '/user/is-authenticated',
    CREATE_USER: '/user/register-user-email-with-password',
    CREATE_USER_MOBILE: '/user/register-user-by-email-or-mobile',
    VERIFY_OTP: '/user/verify-email-or-mobile-otp',
    RESEND_OTP: '/user/send-email-mobile-verification-otp',
    UPDATE_EMAIL_WITH_OTP: '/user/update-email-with-otp',
    UPDATE_MOBILE_WITH_OTP: '/user/update-mobile-with-otp',
    UPDATE_EMAIL: '/user/update-email',
    UPDATE_MOBILE: '/user/update-mobile',
    IS_MOBILE_VERIFIED: '/user/is-mobile-verified',
    IS_EMAIL_VERIFIED: '/user/is-email-verified',
    IS_EMAIL_EXISTS: '/user/email-exists',
    IS_MOBILE_EXISTS: '/user/mobile-exists',
    CREATE_USER_BY_GOOGLE: '/user/auth/google',
    SEARCH_LOCATION: '/infra/search-place',
    DEMO_PROFILE_PIC: '/photo/home-page-demo-image',
    UPLOAD_PROFILE_PHOTO: '/photo/update-profile-image',
    TRANSLATIONS_TA: '/user/translations/ta',
    TRANSLATIONS_EN: '/user/translations/en',
    QUICK_READ_ALOUD_PROMPT: '/QuickReadAloud/prompt',
    QUICK_READ_ALOUD_SCORE: '/QuickReadAloud/score',
};
